
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 20h20a2 2 0 110 4H2a2 2 0 110-4zm8.63-16.07L6.06 15.58A1.038 1.038 0 007.03 17c.435-.003.824-.273.98-.68L8.87 14h6.25l.87 2.32a1.043 1.043 0 101.95-.74L13.37 3.93a1.474 1.474 0 00-2.74 0zM9.62 12L12 5.67 14.38 12H9.62z"}})])
          )
        }
      }
    